module.exports = __webpack_public_path__ + "img/icons8-money-box-100.0227a95d.png";